'use client'

import { useCOISStore } from '@repo/store/useCOISStore'
import { useState } from 'react'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardPanel } from '@repo/ui/WizardPanel'
import MUIAlert from '@mui/material/Alert'
import MUIAlertTitle from '@mui/material/AlertTitle'
import MUICheckbox from '@mui/material/Checkbox'
import MUIFormControlLabel from '@mui/material/FormControlLabel'
import MUITextField from '@mui/material/TextField'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const COISConfirmSearch = ({ wideMode, handlePrevNext }) => {
  const { parties, updateCOISWizardSidebar, acceptanceStatus, acceptanceNotes, updateState } = useCOISStore()
  const [showRequiredFieldAlert, setShowRequiredFieldAlert] = useState(false)

  const totalConflicts = Object.values(parties)?.reduce((acc, party) => acc + party.conflicts?.length, 0) || 0

  const handleClickContinue = () => {
    if (!acceptanceStatus) {
      setShowRequiredFieldAlert(true)
      return
    }

    updateCOISWizardSidebar()

    handlePrevNext(1)
  }

  const handleClickBack = () => {
    updateCOISWizardSidebar()
    handlePrevNext(-1)
  }

  const handleCheckboxChange = (e) => {
    setShowRequiredFieldAlert(!e.target.checked)
    updateState({ key: 'acceptanceStatus', value: e.target.checked })
    updateState({ key: 'acceptanceTimestamp', value: new Date().toISOString() })
  }

  return (
    <>
      <MUIAlert severity="success" sx={{ backgroundColor: 'success.tint', mb: 4 }}>
        <MUIAlertTitle sx={{ fontSize: '16px', fontWeight: '600' }}>Conflict of interest search complete</MUIAlertTitle>
        {totalConflicts} conflict{totalConflicts === 1 ? '' : 's'} reviewed across all parties
      </MUIAlert>

      <WizardPanel data-testid="COISConfirmSearch">
        <MUITypography variant="h5" sx={{ mb: 3 }}>
          Acknowledgement
        </MUITypography>
        <MUIFormControlLabel
          sx={{ mb: 3 }}
          control={<MUICheckbox checked={acceptanceStatus} onChange={handleCheckboxChange} />}
          label="I acknowledge that I have reviewed the conflicts and will proceed to act for this prospect"
        />

        {showRequiredFieldAlert ? (
          <MUIAlert sx={{ mt: -1, mb: 5, userSelect: 'none', pointerEvents: 'none', width: '100%' }} severity="error">
            {'Please acknowledge that you have reviewed the conflicts'}
          </MUIAlert>
        ) : null}

        <MUITextField
          multiline
          value={acceptanceNotes}
          onChange={(e) => updateState({ key: 'acceptanceNotes', value: e.target.value })}
          minRows={8}
          placeholder="Add notes"
        />
      </WizardPanel>
      <WizardFooter wideMode={wideMode} handleClickContinue={handleClickContinue} handleClickBack={handleClickBack} />
    </>
  )
}

COISConfirmSearch.propTypes = {
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func
}
